module.exports = __webpack_public_path__ + "static/media/Mary Beth Cowardin Headshot.6d869f73.jpeg";